import React from 'react';

import * as dateLib from '@utils';

export type DateType = 'date' | 'date-time' | 'timezone' | 'localDate';

const format = (date: string | Date, type: DateType, timeZone: string) => {
  if (!date) {
    return '';
  }
  const parsedDate: Date = date instanceof Date ? date : new Date(date);
  let dateAsString: string;
  switch (type) {
    case 'date-time': {
      dateAsString = dateLib.dateTimeFormat(parsedDate);
      break;
    }
    case 'timezone': {
      dateAsString = dateLib.formatDateWithTimezone(parsedDate, timeZone);
      break;
    }
    case 'date': {
      dateAsString = dateLib.formatDate(parsedDate, dateLib.DATE_OPTIONS);
      break;
    }
    case 'localDate': {
      // this assumes the parsedDate function default a date string with no timezone as UTC timezone
      dateAsString = dateLib.formatDateUTC(parsedDate, dateLib.DATE_OPTIONS);
      break;
    }
    default:
      dateAsString = parsedDate.toString();
      break;
  }
  return dateAsString;
};
interface DateCellProps {
  date: Date | string;
  type: DateType;
  timeZone?: string;
}

const DateCell: React.FC<DateCellProps> = ({ date, type, timeZone = '' }) => {
  return <td className='date-cell'>{format(date, type, timeZone)}</td>;
};

export default React.memo(DateCell);
